module.exports = __webpack_public_path__ + "static/media/water-lower.013f581a.svg";